import React, { useRef, useEffect } from "react";

// Native checkbox with `indeterminate` support (can't be set via markup).
// Generic enough to live in ../../lib/components if you want to share it.
export function CheckBox({ checked, indeterminate, onChange, ariaLabel }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = !!indeterminate;
  }, [indeterminate]);
  return (
    <input
      ref={ref}
      type="checkbox"
      className="form-check-input m-0"
      style={{ cursor: "pointer" }}
      checked={checked}
      onChange={onChange}
      aria-label={ariaLabel}
    />
  );
}
